import { COOKIE_EXPIRY_AUTH } from 'src/constants';

export const getAuthCookieExpiry = () => new Date(new Date().getTime() + COOKIE_EXPIRY_AUTH);
